// Section Components for consistent UI across seller unit pages

interface SectionTitleProps {
	children: React.ReactNode;
	className?: string;
}

export function SectionTitle({ children, className = "" }: SectionTitleProps) {
	return (
		<div className={`py-2.5 border-b border-secondary-600 ${className}`}>
			<h2 className="text-lg font-semibold text-secondary-600">{children}</h2>
		</div>
	);
}

interface SectionContentProps {
	children: React.ReactNode;
	className?: string;
	title?: string;
}

export function SectionContent({ children, className = "", title }: SectionContentProps) {
	return (
		<div className={`p-4 ${className}`}>
			{title && <SectionTitle>{title}</SectionTitle>}
			<div className="mt-3">{children}</div>
		</div>
	);
}
